// Public booking-app origin (serves /u/:username and /u/:username/:slug). In prod this is
// VITE_BOOKING_URL (e.g. https://daycal.app); in dev it falls back to the booking-app dev port.
export const BOOKING_BASE_URL = import.meta.env.VITE_BOOKING_URL || 'http://localhost:5174';

// Where an agency employee (role EMPLOYEE) lands after signing in / when bounced off an
// owner-only route. Their scoped home is their own availability (PRD §5).
export const EMPLOYEE_HOME = '/availability';

// Super admins manage the platform, not host/scheduling features, so they land on the
// control panel (Manage Users) rather than the host dashboard.
export const SUPER_ADMIN_HOME = '/admin/users';

// Post-login landing route for a given user role. Falls back to the host dashboard.
export function homeForRole(role) {
  if (role === 'SUPER_ADMIN') return SUPER_ADMIN_HOME;
  if (role === 'EMPLOYEE') return EMPLOYEE_HOME;
  return '/dashboard';
}
